import { useEffect, useState } from 'react';
import Lottie, { LottieProps, Options } from 'react-lottie';

import LoadingMagenta from '~assets/lotties/loading.json';
import LoadingWhite from '~assets/lotties/loading-white.json';

import { DEFAULT_OPTIONS } from './constants';

interface Props extends Partial<LottieProps> {
  variant?: 'magenta' | 'light';
}

export default function Spinner({ variant = 'magenta', options: optionsProps, ...props }: Props) {
  const [options, setOptions] = useState<Options>();

  useEffect(() => {
    const animationData = variant === 'magenta' ? LoadingMagenta : LoadingWhite;
    setOptions({
      ...DEFAULT_OPTIONS,
      ...optionsProps,
      animationData,
    });
  }, [variant]);
  if (!options) {
    return null;
  }

  return <Lottie options={options} isClickToPauseDisabled {...props} />;
}
